/**
 * Formats string, with newline characters replaced with a comma
 * @param value String to format
 * @returns Formatted string
 */
export function newlineToComma(value?: string): string {
  return value == null ? '-' : `${value}`.replace(/(\r\n|\n\r|\r|\n)/g, ', ').replace(/,,/g, ',')
}
